export default __webpack_public_path__ + "static/media/ilustration-01.a38bade6.svg";